const { REACT_APP_API_PLACEHOLDER } = process.env
export const CATEGORIES        = REACT_APP_API_PLACEHOLDER + '/categories/'
export const NEWS              = REACT_APP_API_PLACEHOLDER + '/news/'
export const BLOGS             = REACT_APP_API_PLACEHOLDER + '/blogs/'



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/apiConst.js